var map = {
	"./amplify-amazon-button_5.entry.js": [
		1416,
		79
	],
	"./amplify-auth-container.entry.js": [
		1417,
		80
	],
	"./amplify-auth-fields_9.entry.js": [
		1418,
		81
	],
	"./amplify-authenticator.entry.js": [
		1419,
		61
	],
	"./amplify-button_3.entry.js": [
		1420,
		82
	],
	"./amplify-chatbot.entry.js": [
		1443,
		49
	],
	"./amplify-checkbox.entry.js": [
		1421,
		83
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		1422,
		62
	],
	"./amplify-container.entry.js": [
		1423,
		84
	],
	"./amplify-federated-buttons_2.entry.js": [
		1424,
		85
	],
	"./amplify-federated-sign-in.entry.js": [
		1425,
		86
	],
	"./amplify-form-field_4.entry.js": [
		1426,
		87
	],
	"./amplify-greetings.entry.js": [
		1427,
		88
	],
	"./amplify-icon-button.entry.js": [
		1428,
		89
	],
	"./amplify-icon.entry.js": [
		1429,
		63
	],
	"./amplify-link.entry.js": [
		1430,
		90
	],
	"./amplify-nav_2.entry.js": [
		1431,
		91
	],
	"./amplify-photo-picker.entry.js": [
		1432,
		92
	],
	"./amplify-picker.entry.js": [
		1433,
		93
	],
	"./amplify-radio-button_3.entry.js": [
		1434,
		64
	],
	"./amplify-s3-album.entry.js": [
		1435,
		0,
		65
	],
	"./amplify-s3-image-picker.entry.js": [
		1436,
		0,
		66
	],
	"./amplify-s3-image.entry.js": [
		1437,
		0,
		67
	],
	"./amplify-s3-text-picker.entry.js": [
		1438,
		0,
		68
	],
	"./amplify-s3-text.entry.js": [
		1439,
		0,
		69
	],
	"./amplify-select-mfa-type.entry.js": [
		1440,
		94
	],
	"./amplify-sign-in-button.entry.js": [
		1441,
		70
	],
	"./amplify-tooltip.entry.js": [
		1442,
		95
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1186;
module.exports = webpackAsyncContext;